import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import { Colors } from '@blueprintjs/core';
import { CLUSTERED_SELECTED_FEATURE_PROPERTY } from 'widgets/earthMap/constants/mapConstants';
import Space from '../../Space';
import Line from '../../Line';

export default function ClusterModal() {
	const [{ hoveredCluster, selectedFeatureProperty }] = useMapContext();
	const [pointCount, setPointCount] = useState<number>(0);
	const [value, setValue] = useState<number>(0);

	useEffect(() => {
		const count = hoveredCluster?.properties?.point_count;
		setPointCount(count);
	}, [hoveredCluster]);

	useEffect(() => {
		const value = hoveredCluster?.properties?.[CLUSTERED_SELECTED_FEATURE_PROPERTY];
		setValue(value);
	}, [hoveredCluster]);

	if (!hoveredCluster) return null;
	return (
		<Wrapper>
			<Title>Cluster</Title>
			<Space space={'6px'} isVertical={true} />
			<Line isVertical={false} />
			<Space space={'6px'} isVertical={true} />
			<Row>
				<SubTitle>Point Count:</SubTitle>
				<Value>{pointCount}</Value>
			</Row>
			{selectedFeatureProperty && (
				<Row>
					<SubTitle>{selectedFeatureProperty}:</SubTitle>
					<Value>{value}</Value>
				</Row>
			)}
			<Row>
				<SubTitle>Latitude:</SubTitle>
				<Value>{hoveredCluster?.geometry?.coordinates?.[1]}</Value>
			</Row>
			<Row>
				<SubTitle>Longitude:</SubTitle>
				<Value>{hoveredCluster?.geometry?.coordinates?.[0]}</Value>
			</Row>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	position: absolute;
	right: 12px;
	top: 12px;
	padding: 12px;
	width: 300px;
	background: ${Colors.WHITE};
`;
const Row = styled.div`
	display: flex;
`;
const Title = styled.div`
	font-weight: bold;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	font-size: 14px;
`;
const SubTitle = styled.div`
	font-weight: bold;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	font-size: 12px;
`;

const Value = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	font-size: 12px;
`;
